import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CropperComponent } from 'src/app/components/misc/cropper/cropper.component';
import { FileService } from 'src/app/services/file.service';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';

@Component({
  selector: 'app-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss'],
  standalone: true,
  imports: [SHARED_IMPORTS, ButtonModule]
})
export class ProfileImageComponent implements OnInit, OnDestroy {
  private dialogService = inject(DialogService);
  private fileService = inject(FileService);

  ref!: DynamicDialogRef;

  @Input() base64Image?: string | null = null;

  @Input() isEditable = true;

  @Output() profilePictureChanged = new EventEmitter<string>();

  ngOnInit(): void {
    if (this.base64Image === null) {
      this.fileService.getFileAsBase64('assets/images/logo.png').subscribe({
        next: (data) => {
          this.base64Image = data;
        },
        error: (error) => {
          console.error('Error loading file:', error);
        }
      });
    }
  }

  openImageCropper() {
    this.ref = this.dialogService.open(CropperComponent, {
      header: '',
      modal: true,
      width: '40%',
      data: {
        base64: this.base64Image
      }
    });

    this.ref.onClose.subscribe((result: string) => {
      if (result) {
        this.base64Image = result;
        this.profilePictureChanged.emit(this.base64Image);
      }
    });
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
}
